exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_users_33AG6gJJUjoPdmZVg0d8i5 {\n  width: 100%;\n  position: relative;\n  float: left;\n}\n\n.IA_users_33AG6gJJUjoPdmZVg0d8i5 h1 {\n  float: left;\n}\n", ""]);

// Exports
exports.locals = {
	"IA_users": "IA_users_33AG6gJJUjoPdmZVg0d8i5"
};